import React from "react";
import image from "../Assets/Chat/747a5d6b0e52325c2669d80bf100b210469b2a50.jpg";
import "../Style/Component/chatcard.css";
const Chatcard = ({ chat, onClick }) => {
  return (
    <div className="chatcard" onClick={onClick} style={{ cursor: "pointer" }}>
      <div className="avatar-wrapper">
        {chat?.profileimage ? (
          <img src={chat.profileimage} alt="profile" className="chat-avatar" />
        ) : (
          <div className="chat-avatar-fallback">
            {chat?.user_name?.[0].toUpperCase()}
            {chat?.user_name?.slice(-1).toUpperCase()}
          </div>
        )}
      </div>

      <div className="chatcardcontent">
        <div className="chatcardheader">
          <span className="namespan">{chat?.user_name}</span>
          <div
            style={{
              width: "28%",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <span
              className="typespan"
              style={{
                background: chat?.roleType !== "driver" ? "#3D42DF" : "#9F0000",
                width: "fit-content",
              }}
            >
              {chat?.roleType === "driver" ? "Driver" : "User"}
            </span>
            {chat?.unread_count > 0 && (
              <span
                style={{
                  width: "20px",
                  height: "20px",
                  borderRadius: "50%",
                  backgroundColor: "#9F0000",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "white",
                  fontSize: "11px",
                }}
              >
                {chat?.unread_count}
              </span>
            )}
          </div>
        </div>
        <div className="chatcardbody">
          <span>{chat?.last_message}</span>
        </div>
      </div>
    </div>
  );
};

export default Chatcard;
